import '../../vendor/slick.js';

/* ================================================================
    SLICK CAROUSEL INITIALIZATIONS
   ================================================================ */

(function ($) {
  function initSlick() {
    const slickContainers = [...document.querySelectorAll('[data-slick-container]')];

    if (slickContainers.length === 0) return;

    slickContainers.forEach((container) => {
      const slickSlider = container.querySelector('[data-slick-slider]');

      if (!slickSlider) return;

      const sliderType = slickSlider.getAttribute('data-slick-slider');
      const previousButton = container.querySelector('[data-slick-previous]');
      const nextButton = container.querySelector('[data-slick-next]');
      const announcer = container.querySelector('[data-slick-announcer]');
      const isAutoplay = container.hasAttribute('data-slick-container');
      const autoplayButton = container.querySelector('[data-autoplay-toggle]');
      const instructionButton = container.querySelector('[slick-popup-toggle]');
      const instructionDialog = container.querySelector('[slick-popup-dialog]');
      const instructionClose = container.querySelector('[slick-popup-close]');
      const instructionText = container.querySelector('[slick-popup-text]');

      let instructions;
      let slickSlides;
      let sliderLength;

      let options = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: previousButton ? $(previousButton) : undefined,
        nextArrow: nextButton ? $(nextButton) : undefined,
        dots: true,
        autoplay: false,
        autoplaySpeed: 8000,
        mobileFirst: true,
      };

      if (sliderType === 'testimonials-slider') {
        instructions =
          'This carousel displays multiple slides. Use the previous and next buttons to navigate through the carousel.';
        setupInstructionsModal();
        options = Object.assign({}, options, {
          dots: false,
          autoplay: false,
        });
      }

      if (sliderType === 'icons-slider') {
        instructions =
          'This carousel displays multiple slides. Use the previous and next buttons to navigate through the carousel.';
        setupInstructionsModal();
        options = Object.assign({}, options, {
          dots: false,
          autoplay: false,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              },
            },
          ],
        });
      }

      if (sliderType === 'hero-slider') {
        instructions =
          'This carousel displays multiple slides. Use the previous and next buttons to navigate through the carousel. Additionally, this slider is set to auto play - use the auto play button to stop or resume.';
        setupInstructionsModal();
        options = Object.assign({}, options, {
          dots: false,
          autoplay: true,
        });
      }

      $(slickSlider).on('afterChange', function (_, __, currentSlide) {
        setInert();
        setAnnouncers(currentSlide);
      });

      $(slickSlider).on('init', function () {
        requestAnimationFrame(() => {
          setInert();
          setupAttributes();
          if (isAutoplay) setupAutoplay();
        });
      });

      $(slickSlider).on('breakpoint', function () {
        setInert();
      });

      $(slickSlider).slick(options);

      slickSlides = [...slickSlider.querySelectorAll('.slick-slide')];
      sliderLength = slickSlides.length;

      function setInert() {
        if (!slickSlides || !Array.isArray(slickSlides) || slickSlides.length === 0) {
          slickSlides = [...slickSlider.querySelectorAll('.slick-slide')];
        }
        if (!slickSlides || slickSlides.length === 0) return;

        slickSlides.forEach((slickSlide) => {
          if (!slickSlide) return;
          slickSlide.setAttribute('role', 'group');
          if (slickSlide.classList.contains('slick-active')) {
            slickSlide.removeAttribute('inert');
          } else {
            slickSlide.setAttribute('inert', '');
          }
        });
      }

      function setupAttributes() {
        if (!slickSlides || !Array.isArray(slickSlides) || slickSlides.length === 0) {
          slickSlides = [...slickSlider.querySelectorAll('.slick-slide')];
          sliderLength = slickSlides.length;
        }
        if (!slickSlides || slickSlides.length === 0) return;

        slickSlides.forEach((slickSlide) => {
          if (!slickSlide) return;
          const slideIndex = slickSlide.getAttribute('data-slick-index');
          const label = `slide ${+slideIndex + 1} of ${sliderLength}`;
          slickSlide.setAttribute('role', 'group');
          slickSlide.setAttribute('aria-label', label);
        });
      }

      function setAnnouncers(slideIndex) {
        if (isAutoplay || !announcer) return;
        if (!slickSlides || !Array.isArray(slickSlides) || slickSlides.length === 0) {
          slickSlides = [...slickSlider.querySelectorAll('.slick-slide')];
        }
        if (!slickSlides || slickSlides.length === 0 || !slickSlides[slideIndex]) return;

        announcer.innerHTML = '';
        const activeSlide = slickSlides[slideIndex];
        const label = activeSlide.getAttribute('aria-label');
        if (label) {
          announcer.innerHTML = `now showing ${label}`;
        }
      }

      function setupAutoplay() {
        if (!autoplayButton) return;

        const playingLabel = autoplayButton.getAttribute('data-autoplay-play');
        const pauseLabel = autoplayButton.getAttribute('data-autoplay-pause');

        autoplayButton.addEventListener('click', (e) => {
          e.preventDefault();
          if (announcer) announcer.innerHTML = '';

          if (autoplayButton.classList.contains('active')) {
            $(slickSlider).slick('slickPause');
            autoplayButton.setAttribute('aria-label', pauseLabel);
            autoplayButton.setAttribute('aria-pressed', 'true');
            autoplayButton.classList.remove('active');
            if (announcer) announcer.innerHTML = 'carousel autoplay is resumed';
          } else {
            $(slickSlider).slick('slickPlay');
            autoplayButton.setAttribute('aria-label', playingLabel);
            autoplayButton.setAttribute('aria-pressed', 'false');
            autoplayButton.classList.add('active');
            if (announcer) announcer.innerHTML = 'carousel autoplay is paused';
          }
        });
      }

      function setupInstructionsModal() {
        if (!instructionText || !instructionButton || !instructionDialog || !instructionClose) return;

        instructionText.innerHTML = `<p class="carousel-instructions__text">${instructions}</p>`;

        instructionButton.addEventListener('click', (e) => {
          e.preventDefault();
          if (instructionDialog) instructionDialog.showModal();
        });

        instructionClose.addEventListener('click', (e) => {
          e.preventDefault();
          closeModal();
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && instructionDialog && instructionDialog.hasAttribute('open')) {
            if (instructionClose) instructionClose.click();
          }
        });
      }

      function closeModal() {
        instructionDialog.setAttribute('data-modal-close', '');
        instructionDialog.addEventListener(
          'animationend',
          () => {
            instructionDialog.removeAttribute('data-modal-close');
            instructionDialog.close();
          },
          { once: true },
        );
      }
    });
  }

  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlick);
  } else {
    initSlick();
  }
})(window.jQuery);
